"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _animator = _interopRequireDefault(require("../animator"));
var _frap = _interopRequireDefault(require("../frap"));
var _icon = _interopRequireDefault(require("../icon"));
var _chevronRight = _interopRequireDefault(require("../../icons/chevron-right"));
var _chevronLeft = _interopRequireDefault(require("../../icons/chevron-left"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./carousel-pager-button.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PagerButton = exports["default"] = /*#__PURE__*/function (_Component) {
  function PagerButton() {
    _classCallCheck(this, PagerButton);
    return _callSuper(this, PagerButton, arguments);
  }
  _inherits(PagerButton, _Component);
  return _createClass(PagerButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        active = _this$props.active,
        directionName = _this$props.directionName,
        style = _this$props.style,
        clickHandler = _this$props.clickHandler,
        carouselId = _this$props.carouselId,
        ariaLabelNext = _this$props.ariaLabelNext,
        ariaLabelPrev = _this$props.ariaLabelPrev,
        alwaysVisible = _this$props.alwaysVisible,
        buttonClassName = _this$props.buttonClassName;
      var config = {
        prev: {
          className: 'carouselPager--prev',
          iconPath: _chevronLeft["default"]
        },
        next: {
          className: 'carouselPager--next',
          iconPath: _chevronRight["default"]
        }
      };
      var direction = config[directionName];
      var pagerLabel = function pagerLabel() {
        if (directionName === 'next') {
          return ariaLabelNext;
        } else if (directionName === 'prev') {
          return ariaLabelPrev;
        }
      };
      var divClasses = (0, _classnames["default"])('absoluteCenter-y carouselPager py2', buttonClassName, direction.className, {
        pl2: directionName === 'next',
        pr2: directionName !== 'next'
      });
      var frapClasses = (0, _classnames["default"])('block color-black60 carouselPager__button', {
        'carouselPager__button--alwaysVisible': alwaysVisible
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        "aria-disabled": !active,
        className: divClasses,
        onClick: clickHandler,
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_animator["default"], null, active && /*#__PURE__*/_react["default"].createElement(_frap["default"], {
        "aria-controls": carouselId,
        circular: true,
        className: frapClasses,
        key: pagerLabel(),
        mini: true
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "hiddenVisually"
      }, pagerLabel()), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        className: "absoluteCenter",
        path: direction.iconPath,
        size: "24px"
      }))));
    }
  }]);
}(_react.Component);
PagerButton.propTypes = process.env.NODE_ENV !== "production" ? {
  active: _propTypes["default"].bool,
  carouselId: _propTypes["default"].string,
  clickHandler: _propTypes["default"].func,
  directionName: _propTypes["default"].oneOf(['next', 'prev']).isRequired,
  ariaLabelNext: _propTypes["default"].string,
  ariaLabelPrev: _propTypes["default"].string,
  alwaysVisible: _propTypes["default"].bool,
  buttonClassName: _propTypes["default"].string
} : {};